// extracted by mini-css-extract-plugin
module.exports = {"dropdownContainer":"language-selector_dropdownContainer__Br2Qo"};